import { useTranslation } from 'react-i18next'
import type { Product } from '@/types/products'
import { EmptyState } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'
import {
  CategoriesCard,
  IdentifiersCard,
  PricesCard,
  DimensionsWeightCard,
  StockProcurementCard,
  SalesChannelsCard,
  StatusTimestampsCard,
  parseJtlMasterData,
} from './masterdata'

/** Provider→Parser-Registry (Hexagonal: neuer Provider = neuer Parser, UI unverändert). */
const PARSERS: Record<string, typeof parseJtlMasterData> = { jtl: parseJtlMasterData }

export function ProductMasterDataTab({ product }: { product: Product }) {
  const { t } = useTranslation()
  const parser = PARSERS[product.provider_type ?? 'jtl']
  const vm = parser ? parser(product.raw_data) : null
  const hasData = vm && Object.values(vm).some((v) => v !== undefined)

  if (!hasData) {
    return (
      <div id={EID['product-masterdata-empty']}>
        <EmptyState
          title={t('productMasterData.empty.title')}
          description={t('productMasterData.empty.description')}
        />
      </div>
    )
  }

  return (
    <section
      id={EID['product-masterdata-tab']}
      className="product-master-data-tab grid gap-4 lg:grid-cols-2"
      aria-label={t('productMasterData.title')}
    >
      {vm.categories && (
        <div className="lg:col-span-2">
          <CategoriesCard groups={vm.categories.groups} total={vm.categories.total} />
        </div>
      )}
      {vm.identifiers && <IdentifiersCard rows={vm.identifiers} />}
      {vm.prices && <PricesCard rows={vm.prices} />}
      {vm.dimensionsWeight && <DimensionsWeightCard rows={vm.dimensionsWeight} />}
      {vm.stockProcurement && <StockProcurementCard rows={vm.stockProcurement} />}
      {vm.salesChannels && <SalesChannelsCard ids={vm.salesChannels} />}
      {vm.status && <StatusTimestampsCard rows={vm.status} />}
    </section>
  )
}
